import { eventTypeStandard, push } from './internal/core';

const LOGIN_PAGE_TYPE = 'login';

export type UseTrackingLoginReturn = {
    trackLoginSuccess: VoidFunction;
};

export const useTrackingLogin = (): UseTrackingLoginReturn => {
    const { data: session } = useAuthUtils();

    return {
        trackLoginSuccess(): void {
            const user = session.value?.user;
            if (!user) return;

            push({
                event: 'login',
                user_id: user.id,
                user_email: user.email,
                page_type: LOGIN_PAGE_TYPE,
                click_element: 'standard_form',
                ...eventTypeStandard,
            });
        },
    };
};
